import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React from 'react';
import classNames from 'classnames';
import { ExternalLinkIcon, LinkIcon } from '@cognite/cogs-icons';
import { getThemeClassNames } from '@cognite/cogs-utils';
import { Button } from '../button/button.js';

/**
 * Link
 * =============================================================================
 * Describe what your component does, and why it could be useful for users.
 *
 * [Open docs »](https://cognitedata.github.io/cogs.js/?path=/docs/components-link--base)
 *
 * -----------------------------------------------------------------------------
 * Examples
 * -----------------------------------------------------------------------------
 * ```
 * <Link href="https://www.cognite.com/">
 *   Cognite.com
 * </Link>
 *
 * <Link href="/">
 *   Home
 * </Link>
 * ```
 *
 * -----------------------------------------------------------------------------
 * Properties
 * -----------------------------------------------------------------------------
 * @param subject - Explain here what your prop does
 *
 * [Read the full documentation »](https://cognitedata.github.io/cogs.js/?path=/docs/components-link--base)
 */
var Link = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var size = _a.size,
    children = _a.children,
    href = _a.href,
    loading = _a.loading,
    disabled = _a.disabled,
    inverted = _a.inverted,
    alignVertically = _a.alignVertically,
    _a$target = _a.target,
    target = _a$target === undefined ? '_self' : _a$target,
    themeProps = _a.themeProps,
    otherProps = __rest(_a, ["size", "children", "href", "loading", "disabled", "inverted", "alignVertically", "target", "themeProps"]);
  // Figure out if the link is internal or external
  var tmpLink = document.createElement('a');
  tmpLink.href = href;
  var isExternalLink = tmpLink.host !== window.location.host;
  var icon = isExternalLink ? jsx(ExternalLinkIcon, {}) : jsx(LinkIcon, {});
  var iconPlacement = isExternalLink ? 'right' : 'left';
  var handleOnClick = function handleOnClick() {
    window.open(href, target);
  };
  return jsx(Button, Object.assign({
    role: "link",
    className: classNames.apply(undefined, ['cogs-v10', 'cogs-link'].concat(getThemeClassNames(inverted, themeProps))),
    onClick: handleOnClick,
    size: size,
    icon: icon,
    type: "ghost-accent",
    iconPlacement: iconPlacement,
    loading: loading,
    alignVertically: alignVertically,
    disabled: disabled,
    ref: ref
  }, otherProps, {
    "aria-label": otherProps['aria-label'] + ". " + (target === '_blank' ? 'Opens in new tab' : ''),
    children: children
  }));
});

export { Link };
